import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Formik } from 'formik';
import { useCallback, useRef, useState } from 'react';
import * as Yup from 'yup';
import { useDispatch } from '../context/DispatchContext';
import ActionButtons from '../elements/ActionButtons';
import CloseButton from '../elements/CloseButton';
import Label from '../elements/Label';
import Select from '../elements/Select';
import FormikInput from '../elements/formik/FormikInput';
import { formatNumber } from '../utility/formatNumber';
import { ModalStyles } from './ModalStyle';
const styles = css `
  width: 400px;
  min-height: 250px;

  .inner-content {
    flex: 1;
  }
`;
const getKindDefaultValues = (kind) => {
    return {
        kind,
        fwhm: 500,
        ...(kind === 'pseudoVoigt' && { mu: 0.5 }),
    };
};
const getValues = (peak, kind) => {
    const { shape } = peak;
    const shapeData = (shape?.kind || '').toLocaleLowerCase() !== kind
        ? {
            ...getKindDefaultValues(kind),
            ...(shape?.fwhm && { fwhm: shape?.fwhm }),
        }
        : shape;
    return shapeData;
};
const validation = (kind) => Yup.object().shape({
    fwhm: Yup.number().required(),
    ...(kind === 'pseudoVoigt' && { mu: Yup.number().required() }),
});
const KINDS = [
    {
        value: 'gaussian',
        label: 'Gaussian',
    },
    {
        value: 'lorentzian',
        label: 'Lorentzian',
    },
    {
        value: 'pseudoVoigt',
        label: 'PseudoVoigt',
    },
];
const labelStyle = {
    container: { paddingTop: '5px' },
    label: { flex: 3, fontSize: '14px', fontWeight: 'normal' },
    wrapper: { flex: 7, display: 'flex' },
};
const inputStyle = { input: { width: '200px', textAlign: 'left' } };
function EditPeakShapeModal({ onClose = () => null, peak, peaksPreferences, }) {
    const dispatch = useDispatch();
    const refForm = useRef();
    const [kind, setKind] = useState(peak.shape?.kind);
    const changePeakShapeHandler = useCallback((values) => {
        dispatch({
            type: 'CHANGE_PEAK_SHAPE',
            payload: {
                id: peak.id,
                shape: {
                    ...values,
                },
            },
        });
        onClose();
    }, [dispatch, onClose, peak.id]);
    const values = getValues(peak, kind);
    const valuePPM = formatNumber(peak.x, peaksPreferences.deltaPPM.format);
    return (_jsxs("div", { css: [ModalStyles, styles], children: [_jsxs("div", { className: "header handle", children: [_jsxs("span", { children: [`Peak Shape Edition ( ${valuePPM} PPM)`, " "] }), _jsx(CloseButton, { onClick: onClose, className: "close-bt" })] }), _jsx("div", { className: "inner-content", children: _jsx(Formik, { enableReinitialize: true, innerRef: refForm, initialValues: values, validationSchema: validation(kind), onSubmit: changePeakShapeHandler, children: _jsxs(_Fragment, { children: [_jsx(Label, { title: "kind : ", style: labelStyle, children: _jsx(Select, { items: KINDS, style: { margin: 0, height: 30 }, value: kind, onChange: (kind) => setKind(kind) }) }), _jsx(Label, { title: "fwhm: ", style: labelStyle, children: _jsx(FormikInput, { name: "fwhm", style: inputStyle }) }), kind === 'pseudoVoigt' && (_jsx(Label, { title: "mu: ", style: labelStyle, children: _jsx(FormikInput, { name: "mu", style: inputStyle }) }))] }) }) }), _jsx("div", { className: "footer-container", children: _jsx(ActionButtons, { style: { flexDirection: 'row-reverse', margin: 0 }, onDone: () => refForm.current.submitForm(), doneLabel: "Save", onCancel: () => onClose?.() }) })] }));
}
export default EditPeakShapeModal;
